import axios, { AxiosRequestConfig } from "axios";
import { format } from "date-fns";
import { AdjustmentAccounts, ObjectToAdjustmentAccounts } from "../Objects/AdjustmentAccounts";
import { AdjustmentCancel, ObjectToAdjustmentCancel } from "../Objects/AdjustmentCancel";
import { AdjustmentCouponGet, ObjectToAdjustmentCouponGet } from "../Objects/AdjustmentCouponGet";
import { AdjustmentCouponUse, ObjectToAdjustmentCouponUse } from "../Objects/AdjustmentCouponUse";
import { AdjustmentDiscount, ObjectToAdjustmentDiscount } from "../Objects/AdjustmentDiscount";
import { AdjustmentEquipment, ObjectToAdjustmentEquipment } from "../Objects/AdjustmentEquipment";
import { AdjustmentStudio, ObjectToAdjustmentStudio } from "../Objects/AdjustmentStudio";
import { CancelCharge, ObjectToCancelCharge } from "../Objects/CancelCharge";
import { CancelData, ObjectToCancelData } from "../Objects/CancelData";
import { ApiError } from "./ApiError";

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'

export type CountRange = "monthly" | "daily"

export interface getAdjustmentListProps {
    str_id: number
    date: Date
    count_range?: CountRange
}
export interface getAdjustmentListResults {
    adj_studio_list: AdjustmentStudio[]
    adj_equipment_list: AdjustmentEquipment[]
    adj_cancel_list: AdjustmentCancel[]
    adj_discount_list: AdjustmentDiscount[]
    adj_accounts_list: AdjustmentAccounts[]
    cancel_list: CancelData[]
    adj_coupon_use_list: AdjustmentCouponUse[]
    adj_coupon_get_list: AdjustmentCouponGet[]
}
export const getAdjustmentList = async ({
    str_id,
    date,
    count_range
}: getAdjustmentListProps, config?: AxiosRequestConfig): Promise<getAdjustmentListResults> => {
    try {
        let params = new URLSearchParams()
        params.append("str_id", str_id.toString())
        switch (count_range) {
            case "monthly":
                params.append("month", format(date, "yyyy-MM"))
                break;
            default:
                params.append("date", format(date, "yyyy-MM-dd"))
                break;
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'adjustment/get_adjustment_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            adj_studio_list: res.data.adj_studio_list.map((data: any) => ObjectToAdjustmentStudio(data)),
            adj_equipment_list: res.data.adj_equipment_list.map((data: any) => ObjectToAdjustmentEquipment(data)),
            adj_cancel_list: res.data.adj_cancel_list.map((data: any) => ObjectToAdjustmentCancel(data)),
            adj_discount_list: res.data.adj_discount_list.map((data: any) => ObjectToAdjustmentDiscount(data)),
            adj_accounts_list: res.data.adj_accounts_list.map((data: any) => ObjectToAdjustmentAccounts(data)),
            cancel_list: res.data.cancel_list.map((data: any) => ObjectToCancelData(data)),
            adj_coupon_use_list: res.data.adj_coupon_use_list.map((data: any) => ObjectToAdjustmentCouponUse(data)),
            adj_coupon_get_list: res.data.adj_coupon_get_list.map((data: any) => ObjectToAdjustmentCouponGet(data)),
        }
    } catch (error) {
        throw error
    }
}

export interface getCancelChargeListProps {
    str_id: number
    show_page: number
    limit: number
    is_add_settled?: boolean
}
export interface getCancelChargeListResults {
    list: CancelCharge[]
    rows: number
}
export const getCancelChargeList = async ({
    str_id,
    show_page,
    limit,
    is_add_settled,
}: getCancelChargeListProps, config?: AxiosRequestConfig): Promise<getCancelChargeListResults> => {
    try {
        let params = new URLSearchParams()
        params.append("str_id", str_id.toString())
        params.append("show_page", show_page.toString())
        params.append("limit", limit.toString())
        params.append("is_add_settled", is_add_settled ? is_add_settled.toString() : "false")

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'adjustment/get_cancel_charge_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            list: res.data.list.map((item: any) => ObjectToCancelCharge(item)),
            rows: parseInt(res.data.rows),
        }
    } catch (error) {
        throw error
    }
}